module.exports = __webpack_public_path__ + "static/affBG.9c812a98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/affBG.jpg
// module id = 834
// module chunks = 278999228825771